import { buildModelManager } from "../builder.js";
const DefaultShopifyOrderSelection = {
  __typename: true,
  id: true,
  additionalFees: true,
  alerts: true,
  billingAddress: true,
  billingStatusMatchesShippingAddress: true,
  browserIp: true,
  buyerAcceptsMarketing: true,
  canMarkAsPaid: true,
  canNotifyCustomer: true,
  cancelReason: true,
  cancellation: true,
  cancelledAt: true,
  capturable: true,
  cartDiscountAmountSet: true,
  cartToken: true,
  checkoutToken: true,
  clientDetails: true,
  closed: true,
  closedAt: true,
  confirmationNumber: true,
  confirmed: true,
  createdAt: true,
  currency: true,
  currentCartDiscountAmountSet: true,
  currentShippingPriceSet: true,
  currentSubtotalLineItemsQuantity: true,
  currentSubtotalPrice: true,
  currentSubtotalPriceSet: true,
  currentTotalAdditionalFeesSet: true,
  currentTotalDiscounts: true,
  currentTotalDiscountsSet: true,
  currentTotalDutiesSet: true,
  currentTotalPrice: true,
  currentTotalPriceSet: true,
  currentTotalTax: true,
  currentTotalTaxSet: true,
  currentTotalWeight: true,
  customerId: true,
  customerJourneySummary: true,
  customerLocale: true,
  discountApplications: true,
  discountCodes: true,
  dutiesIncluded: true,
  edited: true,
  email: true,
  estimatedTaxes: true,
  financialStatus: true,
  fulfillable: true,
  fulfillmentStatus: true,
  fulfillmentsCount: true,
  fullyPaid: true,
  hasTimelineComment: true,
  landingSite: true,
  legacyResourceId: true,
  merchantEditable: true,
  merchantEditableErrors: true,
  merchantOfRecordAppId: true,
  name: true,
  netPaymentSet: true,
  note: true,
  noteAttributes: true,
  orderStatusUrl: true,
  originalTotalAdditionalFeesSet: true,
  originalTotalDutiesSet: true,
  originalTotalPriceSet: true,
  paymentGatewayNames: true,
  phone: true,
  poNumber: true,
  presentmentCurrency: true,
  processedAt: true,
  processingMethod: true,
  purchasingCompanyContactId: true,
  purchasingCompanyId: true,
  purchasingCompanyLocationId: true,
  purchasingEntity: true,
  referringSite: true,
  refundDiscrepencySet: true,
  refundable: true,
  requiresShipping: true,
  restockable: true,
  returnStatus: true,
  risk: true,
  shippingAddress: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyProtect: true,
  shopifyUpdatedAt: true,
  sourceIdentifier: true,
  sourceName: true,
  sourceUrl: true,
  subtotalPrice: true,
  subtotalPriceSet: true,
  tags: true,
  taxExempt: true,
  taxLines: true,
  taxesIncluded: true,
  test: true,
  token: true,
  totalCapturableSet: true,
  totalCashRoundingAdjustment: true,
  totalDiscounts: true,
  totalDiscountsSet: true,
  totalLineItemsPrice: true,
  totalLineItemsPriceSet: true,
  totalOutstanding: true,
  totalOutstandingSet: true,
  totalPrice: true,
  totalPriceSet: true,
  totalReceivedSet: true,
  totalRefundedSet: true,
  totalRefundedShippingSet: true,
  totalShippingPriceSet: true,
  totalTax: true,
  totalTaxSet: true,
  totalTipReceived: true,
  totalTipReceivedSet: true,
  totalWeight: true,
  transactionsCount: true,
  unpaid: true,
  updatedAt: true
};
const modelApiIdentifier = "shopifyOrder";
const pluralModelApiIdentifier = "shopifyOrders";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyOrderSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyOrderSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderSelection,
    namespace: null
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyOrder does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyOrderManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyOrderSelection,
  operations
);
export {
  DefaultShopifyOrderSelection,
  ShopifyOrderManager
};
//# sourceMappingURL=ShopifyOrder.js.map
